import { render } from "./CouponCard.vue?vue&type=template&id=87552a54&scoped=true"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"

import "./CouponCard.vue?vue&type=style&index=0&id=87552a54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87552a54"]])

export default __exports__